import classnames from "classnames";
import { useEffect, useState } from "react";
import { Form } from "reactstrap";
import { CloseIcon } from "../../../constants/icons";
import { Button, TextField, TextGroup, TextLabel } from "../../Styled";
import "./systemSettingStyle.css";

const EditSystemSettingForm = (props) => {
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setErrors(props.errors);
  }, [props]);

  return (
    <div className="modalContent">
      <div className="modalHeader">
        <h4 className="modalTitle">Edit System Setting</h4>
        <span className="closeIcon" onClick={() => props.close(false)}>
          <CloseIcon />
        </span>
      </div>
      <Form className="w-100 white-form" onSubmit={props.submit}>
        <TextGroup className={classnames({ error: errors.setting_key })}>
          <TextLabel>
            Setting Key{" "}
            {Object.keys(props?.requiredField)?.includes("setting_key")
              ? " *"
              : ""}
          </TextLabel>
          <TextField
            className="disabled-field"
            type="text"
            name="setting_key"
            placeholder="Ex: SETTING_KEY"
            disabled={true}
            value={props.fillData.setting_key || ""}
            onChange={props.change}
          />
          {errors.setting_key ? (
            <span className="error-text">{errors.setting_key}</span>
          ) : null}
        </TextGroup>
        <TextGroup className={classnames({ error: errors.setting_value })}>
          <TextLabel>
            Setting Value{" "}
            {Object.keys(props?.requiredField)?.includes("setting_value")
              ? " *"
              : ""}
          </TextLabel>
          <TextField
            type="text"
            name="setting_value"
            placeholder="Enter setting value"
            value={props.fillData.setting_value || ""}
            onChange={props.change}
          />
          {errors.setting_value ? (
            <span className="error-text">{errors.setting_value}</span>
          ) : null}
        </TextGroup>
        <TextGroup
          className={classnames({ error: errors.setting_description })}
        >
          <TextLabel>
            Setting Description{" "}
            {Object.keys(props?.requiredField)?.includes("setting_description")
              ? " *"
              : ""}
          </TextLabel>
          <TextField
            type="text"
            name="setting_description"
            placeholder="Enter setting description"
            value={props.fillData.setting_description || ""}
            onChange={props.change}
          />
          {errors.setting_description ? (
            <span className="error-text">{errors.setting_description}</span>
          ) : null}
        </TextGroup>
        <TextGroup>
          <Button className="importBtn blue px-5 w-auto" type="submit">
            Save Changes
          </Button>
        </TextGroup>
        <hr />
      </Form>
    </div>
  );
};

export default EditSystemSettingForm;
